import { AfterViewInit, Directive, ElementRef, Input, NgZone, OnChanges, OnDestroy, PLATFORM_ID, Renderer2, SimpleChange, SimpleChanges, ViewContainerRef } from '@angular/core';
import { ZoneConfig, ZoneConfigKey } from 'graphql.generated';
import { PrimeNGConfig } from 'primeng/api';
import { Tooltip } from 'primeng/tooltip';

// https://stories.fylehq.com/p/implementing-directive-wrapper-in-angular

// Factory function to create an instance of Tooltip with necessary dependencies.
function TooltipDirectiveFactory(
  platformId: any,
  el: ElementRef,
  zone: NgZone,
  config: PrimeNGConfig,
  renderer: Renderer2,
  vcr: ViewContainerRef,
): Tooltip {
  return new Tooltip(platformId, el, zone, config, renderer, vcr);
}

// Provider object for Tooltip, utilizing the TooltipDirectiveFactory for instantiation.
const TooltipDirectiveProvider = {
  provide: Tooltip,
  useFactory: TooltipDirectiveFactory,
  deps: [PLATFORM_ID, ElementRef, NgZone, PrimeNGConfig, Renderer2],
};

type ZoneConfigTypes = ZoneConfig[ZoneConfigKey];

@Directive({
  selector: '[appShowOverridingConfigs]',
  providers: [ TooltipDirectiveProvider ],
})
export class ShowOverridingConfigsDirective implements OnChanges, AfterViewInit, OnDestroy {

  @Input() appShowOverridingConfigs: ZoneConfigTypes ;

  lastContent: string;

  constructor(
    private tooltip: Tooltip,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {

    const newContent = this.getContent(this.appShowOverridingConfigs);

    this.tooltip.ngOnChanges(this.getChanges(newContent, changes.appShowOverridingConfigs?.isFirstChange()));

    this.lastContent = newContent;
  }

  getContent(config: ZoneConfigTypes): string {
    if (!config?.overridingConfigs?.length) { return ''; }

    const zones = this.appShowOverridingConfigs.overridingConfigs
      .map((oc) => oc.zone)
      .join(', ');
      ;

    return `Overridden in zones: ${zones}`;
  }

  getChanges(currentContent: string, firstChange: boolean) {
    return {
      content: new SimpleChange(this.lastContent, currentContent, firstChange),
    }
  }

  ngAfterViewInit(): void {
    this.tooltip.ngAfterViewInit();
  }

  ngOnDestroy(): void {
    this.tooltip.ngOnDestroy();
  }
}
